





import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { Documentation } from './documentation.model';
import { documentationFacadeBase, IDocumentationState } from './documentation.state';
import { DocumentationService } from './documentation.service';
import { Observable } from 'rxjs';




@Injectable()
export class DocumentationFacade extends documentationFacadeBase  {


 	constructor(_store: Store<IDocumentationState>, private _documentationService: DocumentationService) {
        super( Documentation, _store);
    }
    getDocumentationByName(name: string): Observable<Documentation> {
        return this._documentationService.getDocumentationByName(name);
    }
}
